module.exports = "/images/admiracion.svg";